// test2232
(2232 && 0);
